import { TagVariant } from '@televet/kibble-ui/build/components/Tag';
import { ChannelTagType } from '@televet/shared-types';

export const getTagVariantByType = (tagType: ChannelTagType | null | undefined): TagVariant => {
  switch (tagType) {
    case ChannelTagType.PaymentRequested:
    case ChannelTagType.FormRequested:
    case ChannelTagType.CareCreditCandidate:
      return 'warning';
    case ChannelTagType.TrupanionCandidate:
    case ChannelTagType.HillsDietIssue:
    case ChannelTagType.HillsIDPurchaseRequest:
    case ChannelTagType.CareCandidate:
    case ChannelTagType.SwitchingVets:
      return 'info';
    case ChannelTagType.PaymentReceived:
    case ChannelTagType.FormSubmitted:
      return 'success';
    default:
      return 'default';
  }
};
